export enum EmploymentType {
  FULL_TIME = "FULL_TIME",
  SELF_EMPLOYED = "SELF_EMPLOYED",
  PART_TIME = "PART_TIME",
}
